<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import Vendor from './components/Vendor.vue'
import Merchant from './components/Merchant.vue';

const curTab = ref('vendor')
</script>

<template>
  <div class="black-market-page page">
    <h2>黑市</h2>

    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="摊贩" name="vendor" class="pane" lazy>
        <Vendor class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="行商" name="merchant" class="pane" lazy>
        <Merchant class="pane-item" />
      </el-tab-pane>
    </el-tabs>
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.black-market-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
